// Module
var code = `<div class="slide" data-object-id="{{objectId}}">
   <div class="slide-content">
      <div class="flip-container">
         <div class="flipper">
            <div class="front">
               <div class="bg-image" style="background-image: url({{imagePath}});"></div>
            </div>
            <div class="back">
               <!-- back content -->
               <h{{headlineLevel}} class="headline">
                  <span>{{name}}</span>
               </h{{headlineLevel}}>

               <a href="{{detailUri}}" class="iconright light" title="{{detailLinkText}}: {{name}}">{{detailLinkText}}<i class='icon icon-arrow-right'></i></a>
            </div>
         </div>
      </div>
   </div>
</div>`;
// Exports
module.exports = code;